<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container = undefined;
</script>

<BaseAtom _isotope="TeamMatchRedirect" {...container}>
  <div class="redirect-card-placeholder">
    <span class="redirect-card-placeholder__title">Team Match Redirect</span>
    <span class="redirect-card-placeholder__subtitle">
      Server-only · sends a teamId to its current match (or fallback)
    </span>
  </div>
</BaseAtom>

<style>
  .redirect-card-placeholder {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.75rem 1rem;
    border: 1px dashed #888;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.03);
    color: #666;
    font-family: sans-serif;
    text-align: center;
  }
  .redirect-card-placeholder__title {
    font-size: 0.875rem;
    font-weight: 700;
  }
  .redirect-card-placeholder__subtitle {
    font-size: 0.6875rem;
    opacity: 0.8;
  }</style>
